import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e6c7235"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "margin": "16px"
  }
};
const _hoisted_2 = {
  class: "login-bottom"
};
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_PageNavLayoutCpt = _resolveComponent("PageNavLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavLayoutCpt, null, {
    default: _withCtx(() => [!$data.isShowPage ? (_openBlock(), _createBlock(_component_van_loading, {
      key: 0,
      style: {
        "text-align": "center",
        "margin-top": "30vh"
      },
      color: "#1989fa",
      size: "36"
    })) : (_openBlock(), _createBlock(_component_van_form, {
      key: 1,
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.mobile,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.mobile = $event),
        required: "",
        name: "mobile",
        label: "手机号",
        placeholder: "手机号",
        rules: [{
          required: true,
          message: '请填写手机号'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $data.validateCode,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.validateCode = $event),
        required: "",
        name: "validateCode",
        label: "验证码",
        placeholder: "验证码",
        rules: [{
          required: true,
          message: '请填写验证码'
        }]
      }, {
        button: _withCtx(() => [$data.btnShow ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          block: "",
          loading: $data.codeLoading,
          size: "small",
          onClick: _withModifiers($options.onFreshCodeClick, ["prevent"])
        }, {
          default: _withCtx(() => [_createTextVNode(" 获取验证码 ")]),
          _: 1
        }, 8, ["loading", "onClick"])) : (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          plain: "",
          type: "primary",
          size: "small",
          disabled: $data.isDisable,
          onClick: _withModifiers($options.getNewCode, ["prevent"])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.secText), 1)]),
          _: 1
        }, 8, ["disabled", "onClick"]))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        loading: $data.logging,
        type: "primary",
        "native-type": "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      }, 8, ["loading"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: $data.imgflag ? $data.checkedImg : $data.unCheckedImg,
        onClick: _cache[2] || (_cache[2] = (...args) => $options.test && $options.test(...args)),
        style: {
          "width": "0.9rem",
          "height": "0.9rem",
          "vertical-align": "middle",
          "font-size": "16px"
        }
      }, null, 8, _hoisted_3), _createTextVNode(" 我已同意 "), _createElementVNode("span", {
        class: "login-protocol",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$router.push({
          path: '/loginPrivacy'
        }))
      }, " 《绿城财富隐私政策》 ")])]),
      _: 1
    }, 8, ["onSubmit"]))]),
    _: 1
  });
}